import { SVGProps, memo } from 'react';

function EyeIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      data-testid="eyeIcon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9999 18.5C5.56369 18.5 2.65369 12.5 2.54244 12.2237C2.48748 12.0616 2.48748 11.8859 2.54244 11.7237C2.65369 11.5 5.56369 5.5 11.9999 5.5C18.4362 5.5 21.3462 11.5 21.4574 11.7762C21.5124 11.9384 21.5124 12.1141 21.4574 12.2762C21.3462 12.5 18.4362 18.5 11.9999 18.5Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 15.5C10.0783 15.4917 8.5259 13.9293 8.53004 12.0075C8.53417 10.0857 10.0932 8.53003 12.015 8.53003C13.9368 8.53003 15.4959 10.0857 15.5 12.0075C15.5042 13.9293 13.9518 15.4917 12.03 15.5H12Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default memo(EyeIcon);
